import { useAppDispatch } from 'hooks/useAppDispatch';
import { RefillBalanceModal } from 'pages/CustomerRepresentativeOrdersPage/BalanceInformer/RefillBalanceModal';
import { FC, useState } from 'react';
import { useQuery } from 'react-query';
import { toast } from 'react-toastify';
import { modalActions } from 'reduxStore/reducers/ModalSlice';
import { FinanceService } from 'services/FinanceService';
import { Button } from 'ui/redesign/Button';
import { Input } from 'ui/redesign/Input';
import { PageWrapper } from 'ui/redesign/PageWrapper';
import { Spinner } from 'ui/Spinner';
import { formatAmount } from 'utils/helpers';
import { ROUBLE_SIGN } from 'utils/settings';

export const Balance: FC = () => {
  const [balanceIsLoaded, setBalanceIsLoaded] = useState<boolean>(false);
  const dispatch = useAppDispatch();

  const { isFetching, data } = useQuery(
    ['getVirtualAccount'],
    () => FinanceService.getVirtualAccount(),
    {
      onSuccess() {
        setBalanceIsLoaded(true);
        balanceIsLoaded && toast.success('Баланс успешно обновлен');
      },
    }
  );

  const refilBalanceHandler = () => {
    dispatch(
      modalActions.handleOpenModal({
        content: <RefillBalanceModal />,
        options: {
          title: 'Укажите сумму пополнения',
          withCloseButton: false,
          modalClassName: 'w-full sm:w-[650px] !overflow-visible sm:min-h-72',
          contentClassName: '!overflow-visible',
        },
      })
    );
  };

  const virtualAccount = data?.data;

  const balance =
    String((virtualAccount?.holdingAmount ?? 0) + (virtualAccount?.balance ?? 0)) ?? 0;

  return (
    <PageWrapper title="Баланс">
      {isFetching ? (
        <Spinner />
      ) : (
        <section className="flex cursor-pointer items-center justify-between gap-4 rounded-[0.625rem] hover:bg-light-30 sm:p-4 sm:shadow-profileMenuItem">
          <Input
            value={`${formatAmount(Number(balance), { minimumFractionDigits: 2 })} ${ROUBLE_SIGN}`}
            label="Баланс"
            className="border-0 border-b-2 border-solid border-light-50 text-text-100"
            isClearable={false}
            readOnly
          />
          <Input
            value={`${formatAmount(virtualAccount?.holdingAmount ?? 0, {
              minimumFractionDigits: 2,
            })} ${ROUBLE_SIGN}`}
            label="В процессе оплаты"
            className="border-0 border-b-2 border-solid border-light-50 text-text-100"
            isClearable={false}
            readOnly
          />
          <Input
            value={`${formatAmount(virtualAccount?.balance ?? 0, {
              minimumFractionDigits: 2,
            })} ${ROUBLE_SIGN}`}
            label="Доступно для выплат"
            className="border-0 border-b-2 border-solid border-light-50 text-text-100"
            isClearable={false}
            readOnly
          />
          <Input
            value={`${formatAmount(virtualAccount?.spentAmount ?? 0, {
              minimumFractionDigits: 2,
            })} ${ROUBLE_SIGN}`}
            label="Израсходовано"
            className="border-0 border-b-2 border-solid border-light-50 text-text-100"
            isClearable={false}
            readOnly
          />
          <Button onClick={refilBalanceHandler}>ПОПОЛНИТЬ СЧЕТ</Button>
        </section>
      )}
    </PageWrapper>
  );
};
